import { mapState } from "vuex";
export default {
    data() {
        return {

        }
    },
    computed: {
        // ...mapState('dic', ['$OBS_AK', '$OBS_SK', '$OBS_SERVER', '$OBS_BUCKET', '$OBS_PREFIX'])
    },
    methods: {
        // obsUpload(file, key, callback) {
        //     console.log(file)
        //     let self = this;
        //     self.handleLoading = true;
        //     var ak = self.$OBS_AK;
        //     var sk = self.$OBS_SK;
        //     var server = self.$OBS_SERVER;
        //     var bucket = self.$OBS_BUCKET;
        //     let prefix = self.$OBS_PREFIX;
        //     var obsClient = new ObsClient({
        //         access_key_id: ak,
        //         secret_access_key: sk,
        //         server: server,
        //         timeout: 60 * 5,
        //     });
        //     // put objects
        //     obsClient
        //         .putObject({
        //             Bucket: bucket,
        //             Key: key,
        //             Metadata: { property: "property-value" },
        //             SourceFile: file,
        //         })
        //         .then(function (result) {
        //             if (result.CommonMsg.Status == 200) {
        //                 console.log(result);
        //                 // 上传成功后的操作
        //                 let obsUrl = prefix + key;
        //                 callback && callback(obsUrl,file);
        //             }
        //             self.handleLoading = false;
        //         })
        //         .catch(function (err) {
        //             self.handleLoading = false;
        //         });
        // }
        obsUpload(file, key, callback) {
            let self = this;
            self.handleLoading = true;
            let formData = new FormData();
            formData.append("file", file);
            this.$http
                .post('/account/sys/static/upload', formData)
                .then((res) => {
                    console.log(res)
                    if (res.code == 0) {
                        let obsUrl = res.data;
                        callback && callback(obsUrl, file);
                    } else {
                        this.$message.error(res.msg)
                    }
                    self.handleLoading = false;
                }).catch(err => {
                    this.$message.error('上传失败！');
                    self.handleLoading = true;
                })
        }
    },
}